
































import Vue from 'vue'
import MessagePane from './MessagePane'
import TextInput from './TextInput'
import './ChatComponent.scss'

export default Vue.extend({
  name: 'ChatComponent',
  props: {
    chatData: {
      type: Array,
      required: true
    },
    currentUser: {
      type: String
    },
    authorColor: {
      type: String,
      required: false,
      default: '#555'
    },
    authorTextColor: {
      type: String,
      required: false,
      default: '#FFF'
    },
    defaultColor: {
      type: String,
      required: false,
      default: '#777'
    },
    defaultTextColor: {
      type: String,
      required: false,
      default: '#FFF'
    },
    submitColor: {
      type: String,
      required: false,
      default: '#F24637'
    },
    submitTextColor: {
      type: String,
      required: false,
      default: '#FFF'
    },
    users: {
      type: Array,
      required: false
    },
    mini: {
      type: Boolean,
      required: false,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    inCast: {
      type: Boolean,
      default: false
    },
    docked: {
      type: Boolean,
      default: true
    },
    unreadCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showNewMsg (): boolean {
      return this.unreadCount > 0 && !this.expanded
    }
  },
  methods: {
    toggleChat () {
      this.$emit('toggleChat')
    },
    sendMessage (paramVal) {
      this.$emit('sendMessage', paramVal)
    },
    userSelected (paramUser) {
      this.$emit('userSelected', paramUser)
    }
  },
  components: {
    MessagePane,
    TextInput
  }
})
